// src/com/auth_class/AuthClassGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTH_CLASS Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-09-25 13:37:13 using DbdbTap
 ************************************************ */


export const LIST_AUTH_CLASS = gql`
query ListAuthClass {
    authClassList {
        authClassId
        className
        classRank
        authMemo
        etrace
        store
        showOnList
    }
}
`;

// authClassListUnsafe: [AuthClassSimple]!
export const LIST_AUTH_CLASS_UNSAFE = gql`
query ListAuthClassUnsafe {
    authClassListUnsafe {
        authClassId
        className
    }
}
`;

